<template>
  <div>
    <!-- Статистика только для авторизованных: гостю показываем заглушку и окно входа -->
    <template v-if="!isLoggedIn">
      <AuthRequired />
    </template>
    <template v-else-if="!errorData.status">
      <div class="d-flex flex-column flex-xl-row w-100">
        <TrafficChart class="wrapper_traffic_chart" />
        <div class="d-flex wrapper_similar_sites">
          <SimilarSites />
        </div>
      </div>
      <MarketingChannels />

      <div class="row g-0 flex-column flex-xl-row w-100">
        <div class="d-flex col wrapper_geo">
          <Geo />
        </div>
        <div class="d-flex col wrapper_device_distribution">
          <DeviceDistribution />
        </div>
      </div>

    </template>
    <template v-else>
      <ErrorPage :errorData="errorData" />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TrafficChart from '@/components/widgets/traffic/TrafficChart.vue'
import DeviceDistribution from '@/components/widgets/DeviceDistribution.vue'
import SimilarSites from '@/components/widgets/similar-sites/SimilarSites.vue'
import MarketingChannels from '@/components/widgets/marketing-channels/MarketingChannels.vue'
import Geo from '@/components/widgets/geo/Geo.vue'
import ErrorPage from '@/views/NotFoundPage.vue'
import AuthRequired from '@/components/auth/AuthRequired.vue'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['navigation/domains', 'domains']),
    ...mapGetters(['errorData']),
    ...mapGetters('userInfo', ['isLoggedIn']),
  },
  components: {
    TrafficChart,
    SimilarSites,
    MarketingChannels,
    DeviceDistribution,
    Geo,
    ErrorPage,
    AuthRequired,
  },
  async created() {
    if (!this.isLoggedIn) {
      // Данные не запрашиваем: бэкенд всё равно ответит 401. Гостю показываем
      // только заглушку AuthRequired, окно входа открывается её кнопкой —
      // иначе на экране сначала заглушка, потом поверх неё выезжает попап
      return
    }
    const result = await this.getAndCreateView({
      domains: this['navigation/domains'],
    })
    if (result?.error) return
    this.loadAll()
  },
  methods: {
    ...mapActions(['loadAll', 'getAndCreateView']),
  },
}
</script>
<style scoped>
@media (min-width: 1200px) {
  .wrapper_unique_visitors {
    padding-right: 20px;
  }

  .wrapper_similar_sites {
    padding-left: 20px;
    min-width: 300px;
  }

  .wrapper_device_distribution,
  .wrapper_unique_visitors,
  .wrapper_referrals,
  .wrapper_social_media,
  .wrapper_ad_networks,
  .wrapper_search_traffic,
  .wrapper_organic_vs_paid,
  .wrapper_brend_non_brend,
  .wrapper_keywords,
  .wrapper_geo,
  .wrapper_ecosystem,
  .wrapper_mobile_apps {
    min-width: 450px;
  }

  .wrapper_engagement {
    min-width: 575px;
    flex-basis: calc(100% / 7 * 3);
  }

  .wrapper_referrals,
  .wrapper_social_media,
  .wrapper_search_traffic,
  .wrapper_organic_vs_paid,
  .wrapper_keywords,
  .wrapper_ecosystem {
    padding-right: 20px;
  }

  .wrapper_traffic_chart,
  .wrapper_similar_sites {
    min-width: 350px;
  }

  .wrapper_traffic_chart {
    width: 65%;
  }
  .wrapper_similar_sites {
    width: 35%;
  }
}

@media (max-width: 1200) {
  .wrapper_social_media,
  .wrapper_organic_vs_paid {
    padding-right: 0;
  }

  .wrapper_traffic_chart {
    width: 100%;
  }
  .wrapper_similar_sites {
    width: 100%;
    padding-left: 0;
  }
}

.wrapper_geo {
  max-width: auto;
  width: 100%;
}

@media (min-width: 1200px) {
  .wrapper_device_distribution {
    padding-left: 20px;
  }
}

.wrapper_referrals {
  width: 100%;
}
</style>
